import styled from '@emotion/styled';
import { gridSize } from '@atlaskit/theme';

export const FooterLogoWrapper = styled.div`
  margin-top: ${gridSize}px;
`;
